export default "__VITE_ASSET__CkZmXYgu__"